import { isArray, toast } from 'lib';
import translation from 'translation';

export const errorHandler = ({ error, message = {} }) => {
  const { t } = translation;

  if (error?.response?.data?.errors) {
    toast({
      type: 'error',
      title: t('common:errorOperation'),
      description: Object.values(error?.response?.data?.errors).map(
        (fieldErrors) => (isArray(fieldErrors) ? `${fieldErrors[0]}\n` : '')
      ),
    });
    return;
  }

  toast({
    type: 'error',
    title: message.title || t('common:errorOperation'),
    description: message.description || t('common:error.fallback.description'),
  });
};
